/* istanbul ignore file */
import { ErrorMonitoring } from './ErrorMonitoring';

export class ErrorMonitoringServerService implements ErrorMonitoring {
  addCustomTag() {}
  addCustomTags() {}
  identify() {}
  captureError() {}
}
